import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { ProductImage } from './ProductImage';
const modules = [{
  title: 'Évaluations & Planification Professionnelle™',
  description: 'Organisez rapidement vos groupes grâce à des outils professionnels d\'évaluation et de planification prêts à utiliser. Évaluations fonctionnelles. Équilibre. Mobilité. Force. Coordination. Classification des niveaux. Objectifs. Fiches de suivi. Toute votre organisation commence avec une base claire et professionnelle.'
}, {
  title: "Bibliothèque Complète d'Exercices Senior™",
  description: 'Accédez à une bibliothèque complète d\'exercices classés par objectif, matériel et niveau. Force. Équilibre. Mobilité. Coordination. Souplesse. Prévention des chutes. Travail postural. Chaque exercice comprend des variantes et des adaptations pour répondre facilement aux besoins de vos participants.'
}, {
  title: 'Systèmes de Séances Prêtes à Utiliser™',
  description: 'Préparez rapidement des séances professionnelles grâce à des modèles entièrement prêts à utiliser. Cours de 30, 45 et 60 minutes. Circuits. Cours collectifs. Renforcement. Mobilité. Prévention des chutes. Séances thématiques. Tout est déjà structuré pour vous faire gagner un temps précieux.'
}, {
  title: 'Programmes Complets de Progression™',
  description: 'Construisez facilement des cycles d\'entraînement grâce à des progressions déjà organisées. Programmes de 4, 8 et 12 semaines. Force. Équilibre. Mobilité. Autonomie. Prévention des chutes. Accompagnez chaque participant avec une progression logique et professionnelle.'
}, {
  title: 'Gestion des Participants & Suivi™',
  description: 'Centralisez toutes vos évaluations et le suivi de vos participants dans un seul système. Fiches individuelles. Suivi mensuel. Évaluations. Progression. Objectifs. Rapports. Moins d\'improvisation. Plus d\'organisation.'
}, {
  title: "Mégabanque d'Activités Senior™",
  description: 'Renouvelez facilement vos cours grâce à une bibliothèque d\'activités professionnelles prêtes à intégrer dans vos séances. Jeux moteurs. Circuits. Activités de coordination. Travail cognitif. Séances thématiques. Activités en groupe. Variantes selon les niveaux. Ne manquez plus jamais d\'idées pour préparer vos cours.'
}];
export function ModulesSection() {
  return <section className="py-6 px-4 sm:px-6 bg-white" data-id="element-84" data-mp="36t9l1i2nlwsa">
      <div className="text-center mb-4" data-id="element-85" data-mp="36qx0qy9fbac2">
        <p className="text-[11px] sm:text-sm font-heading font-bold text-petrol uppercase tracking-widest mb-1" data-id="element-86" data-mp="31tn5h1zcs4gb">
          La solution que vous attendiez
        </p>
        <h2 className="text-2xl sm:text-4xl font-display text-navy leading-none mb-2" data-id="element-87" data-mp="2wwoayibs1vhl">
          Un système complet de planification 6-en-1 pour les professionnels du
          fitness senior
        </h2>
        <p className="text-[13px] sm:text-base text-ink leading-snug max-w-2xl mx-auto mb-3" data-id="element-88" data-mp="1he347wx8yub9">
          Six modules professionnels réunis dans un seul système, conçus pour
          vous faire gagner du temps et simplifier votre organisation
          quotidienne.
        </p>

        <div className="inline-block bg-navy text-white px-4 py-1.5 rounded mb-3" data-id="element-89" data-mp="vjjmu7isoon">
          <p className="font-display text-base sm:text-xl tracking-widest" data-id="element-90" data-mp="5v5skrgbfirn">
            SENIOR FITNESS PRO™
          </p>
          <p className="font-heading font-semibold text-[10px] sm:text-xs leading-tight" data-id="element-91" data-mp="apa47o0j0ez2">
            Le Système Complet de Planification 6-en-1 pour les Professionnels
            du Fitness Senior
          </p>
        </div>

        <div className="mb-3" data-id="element-92" data-mp="omox52pzn4vs">
          <ProductImage className="max-w-[210px] sm:max-w-xs" data-id="element-93" data-mp="ooi64oo2q16y" />
        </div>

        <p className="max-w-2xl mx-auto text-ink text-[12.5px] sm:text-base leading-snug" data-id="element-94" data-mp="tmjn941xvqfs">
          SENIOR FITNESS PRO™ n'est pas simplement une collection d'exercices.
          C'est un système complet qui vous aide à préparer vos séances plus
          rapidement, construire des programmes cohérents, suivre efficacement
          la progression de vos participants et travailler avec davantage
          d'organisation.{' '}
          <span className="font-heading font-semibold text-navy" data-id="element-95" data-mp="1v3veh77gwoi1">
            Au lieu de repartir de zéro avant chaque séance... Vous ouvrez
            simplement le système, choisissez les ressources adaptées et
            commencez votre cours avec tout déjà préparé.
          </span>
        </p>
      </div>

      <div className="flex flex-col gap-2 max-w-3xl mx-auto" data-id="element-96" data-mp="1hd9xjo1kqoms">
        {modules.map(module => <div key={module.title} className="bg-cream border border-gold/30 rounded-lg p-3 sm:p-3.5 flex gap-2.5 items-start" data-id="element-97" data-mp="1cfqdu8m3xjng">
            <CheckCircle2Icon className="w-5 h-5 text-petrol shrink-0 mt-0.5" data-id="element-98" data-mp="1mb1x948gnf1j" />
            <div data-id="element-99" data-mp="ylz4p1cag1s9">
              <h3 className="text-[13px] sm:text-base font-heading font-bold text-navy leading-tight mb-0.5" data-id="element-100" data-mp="ylh2lo2y2tcf">
                {module.title}
              </h3>
              <p className="text-ink text-[12.5px] sm:text-sm leading-snug" data-id="element-101" data-mp="35arh0cdnz46l">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}